import { useMutation } from "@tanstack/react-query";

import { TestSignalRequest, TestSignalResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

interface TestSignalParams extends TestSignalRequest {
  workspaceId: number;
  userToken: string;
}

export const useTestSignal = () =>
  useMutation({
    mutationFn: async ({
      workspaceId,
      userToken,
      prompt,
      request_log_id,
    }: TestSignalParams): Promise<TestSignalResponse> => {
      const response = await fetch(ENDPOINTS.signals.test(workspaceId), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({ prompt, request_log_id }),
      });

      return handleResponse(response);
    },
    onError: (error: Error) => {
      displayErrorToast(error.message);
    },
  });
